import { lazy } from 'react';

const PrintOperations = {
  Helmet: lazy(() => import('./components/Helmet')),
  Print: lazy(() => import('./containers/Print')),
  PhysicalProofs: lazy(() => import('./containers/PhysicalProofs')),
  ExtractedLabels: lazy(() => import('./containers/ExtractedLabels')),
  PublicationUpload: lazy(() => import('./containers/PublicationUpload')),
};

export default PrintOperations;
